var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDestinationWeddings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 57,
    viewBox: "0 0 60 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_99_128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.789 37.4931C5.798 37.4819 5.806 37.4708 5.816 37.4596C6.53447 36.6315 7.42218 35.9716 8.41752 35.5259C9.41286 35.0803 10.492 34.8594 11.58 34.8787C10.9233 34.5077 10.2002 34.273 9.45299 34.1883C8.70578 34.1036 7.94941 34.1705 7.228 34.3852C6.1419 34.6684 5.13672 35.2064 4.29355 35.9557C3.45038 36.705 2.79285 37.6447 2.374 38.6989C3.49084 38.237 4.63072 37.8345 5.789 37.4931Z",
    fill: "url(#paint0_linear_99_128)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.12 57.2733H56.88C57.1164 57.2886 57.3511 57.2233 57.5467 57.0878C57.7422 56.9523 57.8874 56.7543 57.959 56.5255C58.0222 56.321 58.0138 56.1006 57.9353 55.9016C57.8568 55.7026 57.7129 55.5371 57.528 55.4331C55.834 54.3022 51.821 52.2796 43.756 51.0879C43.756 51.5733 43.762 52.0202 43.778 52.4164C43.7963 52.7807 43.7414 53.1449 43.6166 53.4871C43.4918 53.8292 43.2997 54.1421 43.052 54.4067C42.8043 54.6714 42.5061 54.8823 42.1755 55.0267C41.845 55.1711 41.4889 55.2459 41.129 55.2467C41.0157 55.2466 40.9025 55.2395 40.79 55.2254L36.59 54.6924C36.2231 54.6418 35.8704 54.5153 35.5538 54.3207C35.2372 54.1262 34.9635 53.8677 34.7497 53.5614C34.5358 53.2551 34.3864 52.9075 34.3108 52.5402C34.2352 52.1729 34.2349 51.7938 34.31 51.4264C34.382 51.0768 34.471 50.6846 34.571 50.2712C33.131 50.2114 31.6 50.18 30 50.18C28.4 50.18 26.869 50.2114 25.428 50.2712C25.528 50.6836 25.617 51.0748 25.688 51.4244C25.7642 51.791 25.7651 52.1697 25.6907 52.5367C25.6162 52.9037 25.468 53.2513 25.2553 53.5577C25.0425 53.8642 24.7698 54.123 24.454 54.318C24.1383 54.5131 23.7863 54.6401 23.42 54.6914L19.207 55.2254C19.0955 55.2395 18.9833 55.2466 18.871 55.2467C18.2061 55.248 17.5653 54.9947 17.077 54.5373C16.7892 54.2679 16.5634 53.9376 16.4156 53.5698C16.2678 53.2021 16.2017 52.8059 16.222 52.4093C16.239 52.0151 16.248 51.5703 16.245 51.092C8.178 52.2796 4.166 54.3022 2.47 55.4341C2.28557 55.5383 2.14227 55.7038 2.06429 55.9026C1.98631 56.1014 1.97844 56.3215 2.042 56.5255C2.11329 56.7543 2.25822 56.9524 2.45364 57.0879C2.64905 57.2235 2.88367 57.2888 3.12 57.2733Z",
    fill: "url(#paint1_linear_99_128)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.271 38.8489C6.50114 39.6786 5.92244 40.671 5.57661 41.7546C5.23077 42.8382 5.12639 43.986 5.271 45.1154C6.28716 43.7038 7.39353 42.3613 8.583 41.0965C9.90477 39.6532 11.3351 38.3159 12.861 37.0969C12.3829 36.9643 11.8897 36.8961 11.394 36.8942C10.6094 36.9056 9.83608 37.0858 9.12531 37.4228C8.41454 37.7598 7.7825 38.2459 7.271 38.8489Z",
    fill: "url(#paint2_linear_99_128)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.655 34.9141C17.1953 33.744 18.8225 32.6962 20.522 31.7799C22.0401 30.9359 23.6119 30.1952 25.227 29.5627C24.2719 29.1689 23.2521 28.961 22.221 28.9497C21.0266 28.9528 19.8525 29.2624 18.808 29.8495C17.8662 30.3086 17.071 31.0271 16.5134 31.9228C15.9558 32.8185 15.6583 33.8551 15.655 34.9141Z",
    fill: "url(#paint3_linear_99_128)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.191 29.8495C40.2137 29.3089 39.1272 29.0019 38.0148 28.9522C36.9024 28.9025 35.7935 29.1114 34.773 29.5627C36.3886 30.1949 37.9608 30.9356 39.479 31.7799C41.1781 32.6964 42.8049 33.7442 44.345 34.9141C44.3417 33.855 44.0441 32.8182 43.4863 31.9225C42.9285 31.0268 42.133 30.3084 41.191 29.8495Z",
    fill: "url(#paint4_linear_99_128)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.855 28.0681L17.895 28.0488C18.5302 26.9852 19.2198 25.9559 19.961 24.9652C18.8525 25.1071 17.7924 25.5112 16.8665 26.1449C15.9406 26.7786 15.1748 27.6242 14.631 28.6132C13.839 29.9327 13.5787 31.5104 13.904 33.0192C14.1773 31.9567 14.671 30.9655 15.3523 30.1117C16.0337 29.2579 16.8869 28.5612 17.855 28.0681Z",
    fill: "url(#paint5_linear_99_128)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.37 28.6122C44.826 27.6229 44.0599 26.7772 43.1336 26.1435C42.2073 25.5097 41.1469 25.1058 40.038 24.9642C40.7801 25.9551 41.4703 26.9847 42.106 28.0488L42.145 28.067C43.1138 28.5599 43.9676 29.2564 44.6497 30.1102C45.3317 30.964 45.8261 31.9554 46.1 33.0182C46.4243 31.509 46.1629 29.9313 45.37 28.6122Z",
    fill: "url(#paint6_linear_99_128)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.827 32.7375C11.7084 31.7615 11.7712 30.7717 12.012 29.8191C11.881 29.7178 11.765 29.6104 11.621 29.5151C10.6851 28.8984 9.6177 28.5165 8.50717 28.4011C7.39663 28.2857 6.27494 28.44 5.235 28.8514C6.98086 29.6806 8.56803 30.8165 9.923 32.2065C10.578 32.2976 11.2182 32.4761 11.827 32.7375Z",
    fill: "url(#paint7_linear_99_128)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.414 0.526665L27.287 1.66869L28.535 3.56666H31.465L32.713 1.66869L31.586 0.526665H28.414Z",
    fill: "url(#paint8_linear_99_128)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 14.7133C21.9991 16.1997 22.4015 17.6577 23.1631 18.928C23.9248 20.1982 25.0165 21.2318 26.3187 21.9158C27.621 22.5998 29.0838 22.9077 30.5472 22.8061C32.0106 22.7044 33.4182 22.197 34.6162 21.3393C35.8142 20.4817 36.7564 19.3068 37.3399 17.943C37.9233 16.5793 38.1256 15.0793 37.9245 13.607C37.7234 12.1346 37.1267 10.7467 36.1996 9.59482C35.2726 8.44296 34.0508 7.57154 32.668 7.07584C32.4728 7.0062 32.3036 6.87689 32.184 6.70573C32.0643 6.53457 32.0001 6.33001 32 6.12026V5.59333H28V6.12026C27.9999 6.33001 27.9357 6.53457 27.816 6.70573C27.6964 6.87689 27.5272 7.0062 27.332 7.07584C25.7734 7.63455 24.4239 8.66886 23.4691 10.0365C22.5143 11.4042 22.001 13.038 22 14.7133ZM30 8.63333C31.1867 8.63333 32.3467 8.98992 33.3334 9.658C34.3201 10.3261 35.0892 11.2756 35.5433 12.3866C35.9974 13.4976 36.1162 14.7201 35.8847 15.8995C35.6532 17.0789 35.0818 18.1622 34.2426 19.0125C33.4035 19.8628 32.3344 20.4419 31.1705 20.6765C30.0067 20.9111 28.8003 20.7907 27.7039 20.3305C26.6075 19.8703 25.6705 19.091 25.0112 18.0912C24.3519 17.0913 24 15.9158 24 14.7133C24.0016 13.1013 24.6342 11.5558 25.7591 10.4159C26.884 9.27603 28.4092 8.63494 30 8.63333Z",
    fill: "url(#paint9_linear_99_128)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.143 37.0969C48.6689 38.3159 50.0992 39.6532 51.421 41.0965C52.6099 42.3612 53.7162 43.7029 54.733 45.1133C54.8776 43.984 54.7732 42.8361 54.4274 41.7525C54.0816 40.6689 53.5029 39.6766 52.733 38.8469C52.0656 38.0418 51.1835 37.4486 50.1922 37.1382C49.2008 36.8279 48.1422 36.8135 47.143 37.0969Z",
    fill: "url(#paint10_linear_99_128)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.212 37.4931C55.3703 37.8336 56.5102 38.2354 57.627 38.6969C57.2079 37.6427 56.5501 36.7031 55.7068 35.9538C54.8635 35.2045 53.8582 34.6665 52.772 34.3832C52.0513 34.1695 51.296 34.103 50.5498 34.1875C49.8035 34.2721 49.0813 34.506 48.425 34.8756C49.5126 34.8573 50.5911 35.0789 51.5857 35.5251C52.5803 35.9713 53.4673 36.6314 54.185 37.4596C54.194 37.4708 54.2 37.4819 54.212 37.4931Z",
    fill: "url(#paint11_linear_99_128)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.438 36.7716C39.9051 41.1477 37.4483 46.3114 36.27 51.8378C36.2498 51.934 36.2497 52.0335 36.2695 52.1297C36.2893 52.226 36.3286 52.3171 36.385 52.3972C36.4386 52.4748 36.5075 52.5402 36.5874 52.5894C36.6673 52.6386 36.7563 52.6705 36.849 52.6829L41.041 53.2139C41.1354 53.2277 41.2316 53.2197 41.3225 53.1906C41.4134 53.1615 41.4966 53.1119 41.566 53.0457C41.6391 52.9779 41.6962 52.8944 41.7333 52.8013C41.7703 52.7082 41.7863 52.6078 41.78 52.5076C41.5203 47.4753 42.6499 42.4693 45.042 38.0514C44.768 37.8609 44.058 37.2691 43.438 36.7716Z",
    fill: "url(#paint12_linear_99_128)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.434 53.0457C18.5035 53.1112 18.5864 53.1602 18.6769 53.1893C18.7673 53.2184 18.863 53.2268 18.957 53.2139L23.157 52.6819C23.2476 52.6681 23.3345 52.6357 23.4124 52.5868C23.4903 52.5378 23.5575 52.4733 23.61 52.3972C23.6668 52.3167 23.7064 52.2251 23.7262 52.1283C23.746 52.0314 23.7456 51.9315 23.725 51.8348C22.5459 46.3099 20.0892 41.1476 16.557 36.7726C15.927 37.2792 15.228 37.8619 14.957 38.0524C17.3484 42.468 18.4783 47.4715 18.22 52.5015C18.2134 52.6027 18.2292 52.704 18.2662 52.7982C18.3032 52.8923 18.3606 52.9769 18.434 53.0457Z",
    fill: "url(#paint13_linear_99_128)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.077 32.2075C51.4319 30.8177 53.0191 29.6821 54.765 28.8534C53.7256 28.4427 52.6047 28.2884 51.4948 28.4033C50.385 28.5182 49.318 28.8989 48.382 29.5141C48.237 29.6083 48.12 29.7167 47.989 29.8181C48.2298 30.771 48.2926 31.7612 48.174 32.7375C48.7823 32.476 49.4223 32.2978 50.077 32.2075Z",
    fill: "url(#paint14_linear_99_128)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_99_128",
    x1: 6.977,
    y1: 34.1527,
    x2: 6.977,
    y2: 38.6989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_99_128",
    x1: 30.0002,
    y1: 50.18,
    x2: 30.0002,
    y2: 57.2755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_99_128",
    x1: 9.03441,
    y1: 36.8942,
    x2: 9.03441,
    y2: 45.1154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_99_128",
    x1: 20.441,
    y1: 28.9497,
    x2: 20.441,
    y2: 34.9141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_99_128",
    x1: 39.559,
    y1: 28.9451,
    x2: 39.559,
    y2: 34.9141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_99_128",
    x1: 16.8642,
    y1: 24.9652,
    x2: 16.8642,
    y2: 33.0192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_99_128",
    x1: 43.1369,
    y1: 24.9642,
    x2: 43.1369,
    y2: 33.0182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_99_128",
    x1: 8.6235,
    y1: 28.3639,
    x2: 8.6235,
    y2: 32.7375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_99_128",
    x1: 30,
    y1: 0.526665,
    x2: 30,
    y2: 3.56666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_99_128",
    x1: 30,
    y1: 5.59333,
    x2: 30,
    y2: 22.8251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_99_128",
    x1: 50.9696,
    y1: 36.8944,
    x2: 50.9696,
    y2: 45.1133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_99_128",
    x1: 53.026,
    y1: 34.1519,
    x2: 53.026,
    y2: 38.6969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_99_128",
    x1: 40.6484,
    y1: 36.7716,
    x2: 40.6484,
    y2: 53.2205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_99_128",
    x1: 19.3489,
    y1: 36.7726,
    x2: 19.3489,
    y2: 53.2198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_99_128",
    x1: 51.377,
    y1: 28.3664,
    x2: 51.377,
    y2: 32.7375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_99_128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 57,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestinationWeddings);
export default __webpack_public_path__ + "static/media/Destination Weddings.b364a932cb6499f82fd3e9a1175cf138.svg";
export { ForwardRef as ReactComponent };